import ContainingFeatureQuery from './ContainingFeatureQuery.js';
/**
 * @memberof geodata
 * @property {number} featureClass
 * @property {feature-references.FeatureSpecifier} containingFeature
 * @property {string} containingFeatureLabel
 * @property {number} coverageRatio
 */
class ContainingFeatureMetadata {
    constructor(props) {
        Object.assign(this, props);
    }
    /**
     * @param {GeoJSON.Feature} feature
     * @return {Promise}
     */
    static forFeature(feature) {
        return ContainingFeatureQuery.create(feature).then(mapData);
    }
}
function resultToCamelCase(feature) {
    return new ContainingFeatureMetadata({
        featureClass: feature.properties.feature_class,
        containingFeature: feature.properties.containing_feature,
        containingFeatureLabel: feature.properties.containing_feature_label,
        coverageRatio: feature.properties.coverage_ratio,
        geometry: feature.geometry,
    });
}
function mapData(data) {
    return data.features.map(resultToCamelCase);
}
export default ContainingFeatureMetadata;
